import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FoldersListCounterComponent } from '@hub4b/controls/datas-list/folders-list-counter/folders-list-counter.component';
import { FoldersListConfiguration } from '@hub4b/models/folders-list-configuration';
import { View } from '@hub4b/models/server/view';
import { BehaviorSubject } from 'rxjs';
import { FoldersListCommandBarComponent } from './folders-list-command-bar/folders-list-command-bar.component';
import { FoldersListSearchBarComponent } from './folders-list-search-bar/folders-list-search-bar.component';

@Component({
    selector: 'app-folders-list-header',
    templateUrl: './folders-list-header.component.html',
    styleUrls: ['./folders-list-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FoldersListSearchBarComponent, FoldersListCounterComponent, FoldersListCommandBarComponent]
})
export class FoldersListHeaderComponent {
    @Input()
    public view: View = null;

    private configuration$ = new BehaviorSubject<FoldersListConfiguration>(null);

    public _internalConfiguration: FoldersListConfiguration;

    @Input()
    set configuration(value) {
        this.configuration$.next(value);
    }

    get configuration() {
        return this.configuration$.getValue();
    }

    constructor() {}
}
